import { render } from "./NewsPerson.vue?vue&type=template&id=37137dca&scoped=true"
import script from "./NewsPerson.vue?vue&type=script&lang=js"
export * from "./NewsPerson.vue?vue&type=script&lang=js"

import "./NewsPerson.vue?vue&type=style&index=0&id=37137dca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37137dca"]])

export default __exports__